import React from 'react';
import styled from 'styled-components';

interface WelcomeScreenProps {
  onGetStarted: () => void;
}

const WelcomeContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px;
  text-align: center;
  background: white;
  margin: 20px;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
`;

const WelcomeIcon = styled.div`
  font-size: 64px;
  margin-bottom: 24px;
`;

const WelcomeTitle = styled.h2`
  font-size: 32px;
  font-weight: 600;
  color: #333;
  margin: 0 0 16px 0;
`;

const WelcomeDescription = styled.p`
  font-size: 18px;
  color: #666;
  line-height: 1.6;
  max-width: 600px;
  margin: 0 0 32px 0;
`;

const ExampleQuestions = styled.div`
  margin: 32px 0;
  text-align: left;
  max-width: 500px;
`;

const ExampleTitle = styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: #4B0082;
  margin: 0 0 16px 0;
`;

const ExampleList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

const ExampleItem = styled.li`
  background: #f8f9fa;
  padding: 12px 16px;
  margin: 8px 0;
  border-radius: 8px;
  border-left: 4px solid #4B0082;
  font-size: 14px;
  color: #555;
`;

const GetStartedButton = styled.button`
  background: linear-gradient(135deg, #4B0082, #6A0DAD);
  color: white;
  border: none;
  padding: 16px 32px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(75, 0, 130, 0.3);
  }
  
  &:active {
    transform: translateY(0);
  }
`;

const WelcomeScreen: React.FC<WelcomeScreenProps> = ({ onGetStarted }) => {
  return (
    <WelcomeContainer>
      <WelcomeIcon>🤖📚</WelcomeIcon>
      
      <WelcomeTitle>Welcome to AI Documentation</WelcomeTitle>
      
      <WelcomeDescription>
        Get instant, intelligent answers about our applications. Ask questions in natural language 
        and receive comprehensive documentation tailored to your needs.
      </WelcomeDescription>
      
      <ExampleQuestions>
        <ExampleTitle>Try asking questions like:</ExampleTitle>
        <ExampleList>
          <ExampleItem>"Show me the architecture of the Cross-Sell MFE"</ExampleItem>
          <ExampleItem>"What technologies does the Hardware Selection app use?"</ExampleItem>
          <ExampleItem>"Compare the deployment strategies of all our MFEs"</ExampleItem>
          <ExampleItem>"Who are the team members for the OST application?"</ExampleItem>
          <ExampleItem>"What's the repository URL for the UOST app?"</ExampleItem>
        </ExampleList>
      </ExampleQuestions>
      
      <GetStartedButton onClick={onGetStarted}>
        💬 Start Asking Questions
      </GetStartedButton>
    </WelcomeContainer>
  );
};

export default WelcomeScreen;
